import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {observer, inject} from 'mobx-react';
import * as React from 'react';
import {IWSPMeshContext} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/contexts/MeshContext';

const styles = require('@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/mesh/Mesh.less');

interface IMeshCopiedRangeProps
{
    ctx?:IWSPMeshContext;
}

@inject('ctx')
@observer
export class MeshCopiedRange extends React.Component<IMeshCopiedRangeProps>
{
    private get _isVisible():boolean
    {
        const {ctx: {sheetId}} = this.props;
        const {meshCopyPaste} = controllers.ui.spreadsheets;

        return meshCopyPaste.isCopiedRangeVisible(sheetId);
    }

    private get _style():React.CSSProperties
    {
        const {ctx} = this.props;
        const {sheetId} = ctx;

        const {meshCopyPaste} = controllers.ui.spreadsheets;

        const copyPasteState = meshCopyPaste.getCopyPasteState(sheetId);
        if( !copyPasteState || copyPasteState.copiedSheetId !== sheetId )
            return null;

        const meshState = controllers.ui.spreadsheets.mesh.getState(ctx);
        const copiedRangeBounds = copyPasteState.getCopiedRangeBounds(meshState);

        if( !copiedRangeBounds )
            return null;

        const {x, y, width, height} = copiedRangeBounds;

        return {
            transform: `translate(${x}px, ${y}px)`,
            width: `${width}px`,
            height: `${height}px`
        };
    }

    public render():JSX.Element
    {
        return this._isVisible && <div
            style={this._style}
            className={styles.copiedRange}
        />;
    }
}
